import {BUSCAR_USUARIOS, BUSCAR_USUARIOS_SISTEMA, LIMPAR_USUARIOS, REMOVER_PERFIL_USUARIO, ADICIONAR_PERFIL_USUARIO} from '../../actions/types'

const initialState = [];

export default function reducerUsuarios (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_USUARIOS: {
      const usuarios = action.payload.data;

      if (usuarios) {
        return usuarios
      }
      return []
    }
    case ADICIONAR_PERFIL_USUARIO: {
      const { usuario, perfil } = action.payload;
      const usuarios = Object.assign([], state.usuarios);
      const usuarioSelecionado = usuarios.find(it => it.id === usuario.id)
            
      const user = Object.assign({}, usuarioSelecionado);
      const perfis = Object.assign([], user.rolesName);

      perfis.push({descricao: perfil.label, valor: perfil.value, identificacao: ''})
      const newUser = Object.assign({}, usuarioSelecionado, { rolesName: perfis });
      const indice = usuarios.indexOf(usuarioSelecionado)
      const novosUsuarios = [...usuarios]
      novosUsuarios[indice] = newUser
            
      return {
        ...state,
        usuarios: novosUsuarios
      }
    }
    case REMOVER_PERFIL_USUARIO: {
      const { usuario, perfil } = action.payload;
      const usuarios = Object.assign([], state.usuarios);
      const usuarioSelecionado = usuarios.find(it => it.id === usuario.id)
            
      const user = Object.assign({}, usuarioSelecionado);
      const perfis = Object.assign([], user.rolesName);

      const newPerfis = perfis.filter(it => it.valor != perfil.value)
      const newUser = Object.assign({}, usuarioSelecionado, { rolesName: newPerfis });
      const indice = usuarios.indexOf(usuarioSelecionado)
      const novosUsuarios = [...usuarios]
      novosUsuarios[indice] = newUser
            
      return {
        ...state,
        usuarios: novosUsuarios
      }
    }
    case BUSCAR_USUARIOS_SISTEMA: {
      const usuarios = action.payload.data;
  
      if (usuarios) {
        return usuarios
      }
      return []
    }

    case LIMPAR_USUARIOS:
      return [];

    default: {
      return state
    }
  }
}
